import { px, rect, cRect, cSpine, mRect, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_arrow: Hull = {
  id: 'hull_arrow',
  name: 'Arrow',
  drawBody: (ctx, p) => {
    cSpine(ctx, 18, 5, p.metal); cRect(ctx, 17, 2, 1, p.metalLight); cRect(ctx, 23, 4, 1, p.primary);
    const profile = [[24,1],[25,2],[26,2],[27,3],[28,3],[29,4],[30,4],[31,5],[32,5],[33,5],[34,5],[35,5],[36,5],[37,5],[38,4],[39,3],[40,2]];
    profile.forEach(([y, hw]) => cRect(ctx, y, hw * 2, 1, p.primary));
    profile.forEach(([y, hw]) => { px(ctx, CENTER - hw, y, p.light); px(ctx, CENTER + hw - 1, y, p.shadow); });
    cRect(ctx, 36, 10, 1, p.shadow); cRect(ctx, 37, 8, 1, p.shadow);
    mRect(ctx, 1, 30, 1, 7, p.accent);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 28 }, cap: (ctx, p) => cRect(ctx, 30, 6, 1, p.dark) },
    [SLOT.WING_L]:     { anchor: { x: 27, y: 35 }, cap: (ctx, p) => { rect(ctx, 26, 34, 3, 3, p.shadow); rect(ctx, 26, 34, 3, 1, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 36, y: 35 }, cap: (ctx, p) => { rect(ctx, 35, 34, 3, 3, p.shadow); rect(ctx, 35, 34, 3, 1, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 30, y: 41 }, cap: (ctx, p) => { rect(ctx, 29, 40, 3, 2, p.shadow); px(ctx, 29, 40, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 34, y: 41 }, cap: (ctx, p) => { rect(ctx, 32, 40, 3, 2, p.shadow); px(ctx, 34, 40, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 24 }, base: (ctx, p) => { cRect(ctx, 25, 2, 3, p.metalDark); cRect(ctx, 25, 2, 1, p.metal); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 17 } },
  },
};
